<template>
  <div>
    <b-form-row>
      <h5 class="col-12 text-primary font-weight-bold pb-2">
        Road Construction Reminders
      </h5>
      <b-col v-if="objectAndPropsNotEmpty(reminders)">
        <b-alert v-if="reminders.noLUPCZone" variant="danger" show>
          You have indicated that you plan to construct land management roads. This
          activity is allowed without a permit but
          <a :href="links.chapter27Rules" target="_blank" rel="noopener noreferrer">Chapter 27</a>
          standards must be followed.
        </b-alert>
        <b-alert v-if="reminders.alterationPermitRequired" variant="danger" show>
          You plan on altering an acre or more over a two year period in a P-WL1 or P-WL2
          subdistrict. A permit is required prior to the start of your planned activity. 
          Contact the Maine Forest Service at <a href="mailto:forestinfo@maine.gov">forestinfo@maine.gov</a> or 207-287-2791.
        </b-alert>
        <b-alert v-if="reminders.alterationAcre" variant="danger" show>
          If you plan on altering an acre or more over a two year period in FEMA zones A, AE, A1-30,
          VE, a permit is required prior to the start of your planned activity. 
          Contact the Maine Forest Service at <a href="mailto:forestinfo@maine.gov">forestinfo@maine.gov</a> or 207-287-2791.
        </b-alert>
        <b-alert v-if="reminders.temporaryRoadInSWSTown" variant="danger" show>
          All roads in place beyond 7 months are considered permanent and require a permit from
          the Maine Forest Service. Refer to
          <a :href="links.chapter21Section11" target="_blank" rel="noopener noreferrer">
            Section 11, Chapter 21</a>.
        </b-alert>
        <b-alert v-if="reminders.temporaryRoadInOrganizedTown" variant="danger" show>
          All roads in place beyond 7 months are considered permanent and require a permit from
          the Maine Forest Service. Refer to Natural Resources Protection Act
          <a :href="links.nrpaChapter305" target="_blank" rel="noopener noreferrer">Chapter 305</a>.
        </b-alert>
        <b-alert v-if="reminders.femaZone" variant="danger" show>
          If any of your planned land management roads are located in FEMA zones A, AE, A1-30 or VE,
          then a
          <a :href="links.roadPermit" target="_blank" rel="noopener noreferrer">
            Road Permit
          </a>must be submitted to the Maine Forest Service and approved prior to
          the start of your planned activity.
        </b-alert>
        <b-alert v-if="arrayNotEmpty(reminders.noPermitRequiredSubdistricts)" variant="danger" show>
          You have indicated that you plan to construct land management roads in {{reminders.noPermitRequiredSubdistricts.length === 1 ? 'a' : 'the'}} {{joinList(reminders.noPermitRequiredSubdistricts)}} protection
          {{pluralizeMultiple('subdistrict', reminders.noPermitRequiredSubdistricts)}}. This
          activity is allowed without a permit, but
          <a :href="links.chapter27Rules" target="_blank" rel="noopener noreferrer">Chapter 27</a>
          standards must be followed.
        </b-alert>
        <b-alert
          v-if="arrayNotEmpty(reminders.foPermitMaybeRequiredSubdistricts)"
          variant="danger"
          show
        >
          You have indicated that you plan to construct land management roads in {{reminders.foPermitMaybeRequiredSubdistricts.length === 1 ? 'a' : 'the'}} {{joinList(reminders.foPermitMaybeRequiredSubdistricts)}} protection
          {{pluralizeMultiple('subdistrict', reminders.foPermitMaybeRequiredSubdistricts)}}. A
          <a :href="links.operationsPermit" target="_blank" rel="noopener noreferrer">
            Road Construction Permit</a> may be required, depending on your specific activity and
          location. Please contact the Maine Forest Service for more information.
        </b-alert>
        <b-alert v-if="arrayNotEmpty(reminders.permitRequiredSubdistricts)" variant="danger" show>
          You have indicated that you plan to construct land management roads in {{reminders.permitRequiredSubdistricts.length === 1 ? 'a' : 'the'}} {{joinList(reminders.permitRequiredSubdistricts)}} protection
          {{pluralizeMultiple('subdistrict', reminders.permitRequiredSubdistricts)}}. A
          <a :href="links.operationsPermit" target="_blank" rel="noopener noreferrer">
            Road Construction Permit</a> must be submitted to the Maine Forest Service and approved,
          prior to the start of your planned activity.
        </b-alert>
        <b-alert
          v-if="arrayNotEmpty(reminders.lupcPermitMaybeRequiredSubdistricts)"
          variant="danger"
          show
        >
          You have indicated that you plan to construct land management roads in {{reminders.lupcPermitMaybeRequiredSubdistricts.length === 1 ? 'a' : 'the'}} {{joinList(reminders.lupcPermitMaybeRequiredSubdistricts)}} protection
          {{pluralizeMultiple('subdistrict', reminders.lupcPermitMaybeRequiredSubdistricts)}}. A
          permit issued by the <a :href="links.lupc" target="_blank" rel="noopener noreferrer">
            Maine Land Use Planning Commission</a> may be required. Please contact LUPC for
          more information.
        </b-alert>
        <b-alert v-if="reminders.pfwSubdistrict" variant="danger" show>
          <span>You have indicated that you plan to construct land management roads in a P-FW protection subdistrict.</span>&nbsp;
          <span>A consultation with <a :href="links.mdifw" target="_blank" rel="noopener noreferrer">Maine Inland Fisheries and Wildlife</a> (IF&amp;W) is required before you begin your activity.</span>&nbsp;
          <span>Please contact IF&W for more information.</span>
        </b-alert>
      </b-col>
      <b-col v-else>
        There are no important reminders.
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Utilities from '@/mixins/Utilities';

export default {
  name: 'RoadReminders',
  mixins: [Utilities],
  computed: {
    ...mapState('Configuration', {
      links: state => state.links,
    }),
    ...mapState('Notification', {
      reminders: state => state.importantReminders.roadConstructionReminders,
    }),
  },
};
</script>
